import script from "./SwitchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
